'use client';
import { formattedEligibilityDates } from 'lib/eligibilityFormulas';

type GraphicDateTimelineProps = {
  birthdate: string;
  extended?: boolean;
};

const GraphicDateTimeline = ({
  birthdate,
  extended,
}: GraphicDateTimelineProps) => {
  const {
    bornFirstDay,
    earlyIEPCutoff,
    earlyIEPCutoffMonth,
    firstCoverageStartDate,
    iepEndDate,
    iepEndDateMonth,
    iepStartDate,
    iepStartDateMonth,
  } = formattedEligibilityDates(birthdate);

  return (
    <div>
      {!extended && <h2>Your Initial Enrollment Period</h2>}

      <div className="graphic-timeline">
        <div className="month-block flag">
          <div className="build -green">
            <span></span>
            {iepStartDateMonth}
          </div>
          <div className="annotation">
            <h4>First day you can sign up</h4>
            <p>{iepStartDate}</p>
          </div>
        </div>

        <div className="month-block">
          <div className={`build ${extended ? '-green' : ''}`}>
            <span></span>
          </div>
        </div>

        <div className={`month-block ${extended ? 'flag -right' : ''}`}>
          <div className={`build ${extended ? '-green' : ''}`}>
            <span></span>
            {extended && earlyIEPCutoffMonth}
          </div>
        </div>

        <div className="month-block">
          <div className={`build ${bornFirstDay ? '' : 'cake'}`}>
            <span></span>
          </div>

          {extended && <div className="star" />}
        </div>

        <div className="month-block">
          <div className={`build ${bornFirstDay ? 'cake' : ''}`}>
            <span></span>
          </div>
        </div>

        <div className="month-block">
          <div className="build">
            <span></span>
          </div>
        </div>

        <div className="month-block flag -right">
          <div className="build -red">
            <span></span>
            {iepEndDateMonth}
          </div>
          <div className="annotation">
            <h4>Last day of your Initial Enrollment Period</h4>
            <p>{iepEndDate}</p>
          </div>
        </div>

        {extended && (
          <div>
            <p>Your Medicare coverage start date depends on when you enroll.</p>
            <span className="disclosure">
              <span className="star"></span>
              <p>
                If you sign up between {iepStartDate} and {earlyIEPCutoff}, your
                coverage will start on <b>{firstCoverageStartDate}</b>.
              </p>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default GraphicDateTimeline;
